import { render } from "./piggy-bank-icon.vue.js?vue&type=template&id=8e7614bc!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./piggy-bank-icon.vue?vue&type=template&id=8e7614bc"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__